import React from 'react';
import TeacherDashboardLayout from 'version-two/layout/TeacherDashboardLayout';
import {
  TabPanel,
  TabPanels,
  Tabs,
  // useBreakpointValue,
} from '@chakra-ui/react';
// import AppText from 'version-two/components/Typography/AppText';
// import { CopyContentIcon, ManageLockIcon } from 'version-two/assets';
// import GroupUserProfileImage from 'version-two/components/GroupUserProfileImage/GroupUserProfileImage';
// import TeacherProgramDetailDrawable from 'version-two/components/TeacherProgramDetailDrawable/TeacherProgramDetailDrawable';
// import ManageModuleAccessBulk from 'version-two/components/ManageModuleAccessBulk/ManageModuleAccessBulk';
import { useQuery } from 'react-query';
import { GET_TEACHER_ID_MODULE } from 'version-two/api/urls/teacher';
import makeGetRequest from 'version-two/api/utils/makeGetRequest';
import AppLoader from 'version-two/components/AppLoader/AppLoader';
import { useParams } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import AppFlex from 'version-two/components/chakraLayoutOverrides/AppFlex';
// import { Select } from 'chakra-react-select';
// import useStudentSearch from 'version-two/hooks/useStudentSearch';
import {
  MAKE_TEACHER_PROGRAM_DETAIL,
  TEACHER_DASHBOARD,
} from 'version-two/navigation/routes';
// import appColors from 'version-two/theme/appColors';
import TeacherCourseMaterial from 'version-two/components/TeacherTabs/TeacherCourseMaterial';
import TeacherScheduleTab from 'version-two/components/TeacherTabs/TeacherScheduleTab';
import TeacherSessionFlow from 'version-two/components/TeacherTabs/TeacherSessionFlow';
import TeacherZoomDetails from 'version-two/components/TeacherTabs/TeacherZoomDetails';
import ActiveStudentsTab from 'version-two/components/TeacherTabs/ActiveStudentsTab';

function TeacherProgramDetail() {
  const [tabIndex, setTabIndex] = React.useState(0);
  // const navigate = useNavigate();

  const { programSlug } = useParams();

  const { data: programDetail, isLoading: programDetailIsLoading } = useQuery(
    GET_TEACHER_ID_MODULE(programSlug),
    () => makeGetRequest(GET_TEACHER_ID_MODULE(programSlug)),
  );
  // const isMobile = useBreakpointValue({ base: true, sm: false });

  // const [activeModule, setActiveModule] = useState();

  // const {
  //   isOpen: programDrawableIsOpen,
  //   onOpen: programDrawableOnOpen,
  //   onClose: programDrawableOnClose,
  // } = useDisclosure();

  // const {
  //   isOpen: moduleManageIsOpen,
  //   onOpen: moduleManageOnOpen,
  //   onClose: moduleManageOnClose,
  // } = useDisclosure();

  // const handleManageClick = (module) => {
  //   setActiveModule(module);
  //   moduleManageOnOpen();
  // };

  // const handleManageClose = () => {
  //   moduleManageOnClose();
  // };

  // const handleNavigateToDrawable = (module) => {
  //   navigate(MAKE_TEACHER_PROGRAM_DETAIL_CONTENT(programSlug, module.id));
  // };

  // const handleContentOpen = (module) => {
  //   setActiveModule(module);
  //   programDrawableOnOpen();
  // };

  // const handleDrawableClose = () => {
  //   setActiveModule(null);
  //   programDrawableOnClose();
  // };
  // const handleContentClose = () => {
  //   navigate(MAKE_TEACHER_PROGRAM_DETAIL(programSlug));
  //   handleDrawableClose();
  // };

  // const { searchDefaultProps } = useStudentSearch({ programSlug });

  // useEffect(() => {
  //   if (programDetail && moduleSlug) {
  //     programDetail.data.modules.some((programData) => {
  //       if (programData.id === moduleSlug) {
  //         handleContentOpen(programData);
  //         console.log('matched');
  //         return true;
  //       }
  //       return false;
  //     });
  //   }

  //   if (!moduleSlug) {
  //     handleDrawableClose();
  //   }
  // }, [moduleSlug, programDetail]);

  const pageBreadCrumbDetail = [
    {
      name: 'Your Batches',
      link: TEACHER_DASHBOARD,
    },
    {
      name: `${programDetail?.data.batch.week_day}s ${
        programDetail?.data.batch.batch_timings.split('I')[0]
      }`,
      link: MAKE_TEACHER_PROGRAM_DETAIL(programSlug),
    },
  ];
  const handleTabsChange = (index) => {
    setTabIndex(index);
  };

  return (
    <Tabs variant="teacherTab" index={tabIndex} onChange={handleTabsChange}>
      <TeacherDashboardLayout
        tabIndex={tabIndex}
        isProgram
        breadCrumb={pageBreadCrumbDetail}
      >
        <AppLoader isLoading={programDetailIsLoading}>
          <TabPanels>
            <TabPanel padding="0px">
              <TeacherCourseMaterial />
            </TabPanel>
            <TabPanel padding="0px">
              <TeacherSessionFlow />
            </TabPanel>
            <TabPanel padding="0px">
              <TeacherScheduleTab />
            </TabPanel>
            <TabPanel padding="0px">
              <TeacherZoomDetails />
            </TabPanel>
            <TabPanel padding="0px">
              <ActiveStudentsTab />
            </TabPanel>
          </TabPanels>
        </AppLoader>
      </TeacherDashboardLayout>
    </Tabs>
  );
}

export default TeacherProgramDetail;
